// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/rotate_project_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProjectImage } from "./vision_asset_pb";
import { file_vision_assets_v1_vision_asset } from "./vision_asset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/rotate_project_image.proto.
 */
export const file_vision_assets_v1_rotate_project_image: GenFile = /*@__PURE__*/
  fileDesc("Cit2aXNpb24vYXNzZXRzL3YxL3JvdGF0ZV9wcm9qZWN0X2ltYWdlLnByb3RvEhdwcm90b3MudmlzaW9uLmFzc2V0cy52MSKWAQoZUm90YXRlUHJvamVjdEltYWdlUmVxdWVzdBJJCgZwYXJhbXMYASABKAsyOS5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5Sb3RhdGVQcm9qZWN0SW1hZ2VSZXF1ZXN0LlBhcmFtcxouCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIQCghpbWFnZV9pZBgCIAEoCSKoAQoaUm90YXRlUHJvamVjdEltYWdlUmVzcG9uc2USSgoGcmVzdWx0GAEgASgLMjoucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuUm90YXRlUHJvamVjdEltYWdlUmVzcG9uc2UuUmVzdWx0Gj4KBlJlc3VsdBI0CgVpbWFnZRgBIAEoCzIlLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLlByb2plY3RJbWFnZWIGcHJvdG8z", [file_vision_assets_v1_vision_asset]);

/**
 * @generated from message protos.vision.assets.v1.RotateProjectImageRequest
 */
export type RotateProjectImageRequest = Message<"protos.vision.assets.v1.RotateProjectImageRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.RotateProjectImageRequest.Params params = 1;
   */
  params?: RotateProjectImageRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.RotateProjectImageRequest.
 * Use `create(RotateProjectImageRequestSchema)` to create a new message.
 */
export const RotateProjectImageRequestSchema: GenMessage<RotateProjectImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_rotate_project_image, 0);

/**
 * @generated from message protos.vision.assets.v1.RotateProjectImageRequest.Params
 */
export type RotateProjectImageRequest_Params = Message<"protos.vision.assets.v1.RotateProjectImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 2;
   */
  imageId: string;
};

/**
 * Describes the message protos.vision.assets.v1.RotateProjectImageRequest.Params.
 * Use `create(RotateProjectImageRequest_ParamsSchema)` to create a new message.
 */
export const RotateProjectImageRequest_ParamsSchema: GenMessage<RotateProjectImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_rotate_project_image, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.RotateProjectImageResponse
 */
export type RotateProjectImageResponse = Message<"protos.vision.assets.v1.RotateProjectImageResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.RotateProjectImageResponse.Result result = 1;
   */
  result?: RotateProjectImageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.RotateProjectImageResponse.
 * Use `create(RotateProjectImageResponseSchema)` to create a new message.
 */
export const RotateProjectImageResponseSchema: GenMessage<RotateProjectImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_rotate_project_image, 1);

/**
 * @generated from message protos.vision.assets.v1.RotateProjectImageResponse.Result
 */
export type RotateProjectImageResponse_Result = Message<"protos.vision.assets.v1.RotateProjectImageResponse.Result"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ProjectImage image = 1;
   */
  image?: ProjectImage | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.RotateProjectImageResponse.Result.
 * Use `create(RotateProjectImageResponse_ResultSchema)` to create a new message.
 */
export const RotateProjectImageResponse_ResultSchema: GenMessage<RotateProjectImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_rotate_project_image, 1, 0);

